module.exports = __webpack_public_path__ + "img/envelope.0359d37f.png";